import React from 'react'
import Avatar from '@mui/material/Avatar'
import Box from '@mui/material/Box'
import Tooltip from '@mui/material/Tooltip'
import { Typography } from '@mui/material'

const StepperAvatarDropDown = ({ el }) => {
  const names = el?.members?.map((el2) => el2?.name)
  const profilePhotos = el?.members?.map((el2) => el2?.profile_image_url)

  const getInitialsName = (name) => {
    return name.charAt(0)
  }

  const CustomAvatar = ({ index, sx, radius }) => {
    return profilePhotos[index] ? (
      <Avatar src={profilePhotos[index]} sx={{ height: radius, width: radius, ...sx }} />
    ) : (
      <Avatar
        sx={{
          bgcolor: 'alternate.main',
          height: radius,
          width: radius,
          ...sx,
        }}
      >
        <Typography variant="body1">{getInitialsName(names[index])}</Typography>
      </Avatar>
    )
  }

  return (
    <Tooltip
      title={names?.map((item, index) => (
        <Box key={index}>{item}</Box>
      ))}
    >
      <Box height="100%" width="100%" display="flex" justifyContent="center" alignItems="center">
        {names?.length === 1 ? (
          <CustomAvatar index={0} radius={40} />
        ) : names?.length === 2 ? (
          <Box position="relative" width="100%" height="100%">
            <CustomAvatar index={0} sx={{ position: 'absolute', top: 0, left: 5 }} radius={40} />
            <CustomAvatar index={1} sx={{ position: 'absolute', top: 20, left: 25 }} radius={40} />
          </Box>
        ) : names?.length > 2 ? (
          <Box>
            <CustomAvatar index={0} sx={{ position: 'absolute', top: 0, left: 5 }} radius={40} />
            <Avatar
              sx={{
                bgcolor: 'alternate.main',
                position: 'absolute',
                top: 20,
                left: 25,
                height: 40,
                width: 40,
              }}
            >
              <Typography variant="body1">{names?.length}</Typography>
            </Avatar>
          </Box>
        ) : null}
      </Box>
    </Tooltip>
  )
}

export default StepperAvatarDropDown
